module.exports = __webpack_public_path__ + "static/media/icon-twitter.397dd578.svg";